
<template lang="html">
    <div>

    </div>
</template>


<script>
import { mapState } from 'vuex';

export default {
    name: 'BajajEMI',
    computed: {
        ...mapState({
        }),
    },
    methods: {

    }
}

</script>

<style>

</style>
